module.exports = __webpack_public_path__ + "media/images/partners/depkult2025w-cb8b071ac48380f10ea4c2bd0cd102cf.svg";